import React from "react";
import SecondaryButtonAccent from "../../components/Buttons/SecondaryButtonAccent";
import PrimaryButton from "../../components/Buttons/PrimaryButton";
import PlusIcon from "../../components/Icons/solid/PlusIcon";
import { COLORS, USER_TYPES } from "../../config";
import AddTreatmentTransactionModal from "./AddTreatmentTransactionModal";
import useTreatments from "../../store/treatments/treatmentsContext";
import RemoveTreatmentTransactionModal from "./RemoveTreatmentTransactionModal";
import TreatmentTransactionDetails from "./TreatmentTransactionDetails";
import useApp from "../../store/app/appContext";
import { useHistory } from "react-router-dom";
import ViewTransactionDescriptionModal from './ViewTransactionDescriptionModal';

export default function TreatmentTransactions({ treatmentInfo }) {
  const {
    appState: { user },
  } = useApp();

  const history = useHistory();

  const {
    createTreatmentTransaction,
    getTreatmentTransactions,
    removeTreatmentTransaction,
  } = useTreatments();

  const treatmentId = treatmentInfo._id;

  const [showAddTreatmentTransaction, setShowAddTreatmentTransaction] = React.useState(false);
  const [showRemoveTransaction, setShowRemoveTransaction] = React.useState(false);
  const [selectedTransaction, setSelectedTransaction] = React.useState({
    id: "",
    amount: null,
    description: null
  });

  const [ showTransactionDescription, setShowTransactionDescription] = React.useState(false);

  const [ treatmentTransactions, setTreatmentTransactions ] = React.useState([]);

  const fetchTreatmentTransactions = () => {
    getTreatmentTransactions(treatmentId).then(res => {
      setTreatmentTransactions(res);
    });
  }

  const handleRemoveTreatmentTransaction = (treatmentId, transactionId) => {
    removeTreatmentTransaction(treatmentId, transactionId).then(res => {
      let updatedArray = treatmentTransactions.filter(t => t._id !== transactionId);
      setTreatmentTransactions(updatedArray);
    })
  }
  
  React.useEffect(() => {
    if (treatmentId) {
      fetchTreatmentTransactions();
    }
    
  }, [treatmentId]);

  return (
    <React.Fragment>
      {(user.user_type === USER_TYPES.ROOT || user.user_type === USER_TYPES.STAFF) && (
        <>
          <AddTreatmentTransactionModal
            createTreatmentTransaction={createTreatmentTransaction}
            setShowAddTreatmentTransaction={setShowAddTreatmentTransaction}
            showAddTreatmentTransaction={showAddTreatmentTransaction}
            treatmentId={treatmentId}
            updateTransactions={fetchTreatmentTransactions}
          />

          <RemoveTreatmentTransactionModal
            removeTreatmentTransaction={handleRemoveTreatmentTransaction}
            showRemoveTransaction={showRemoveTransaction}
            setShowRemoveTransaction={setShowRemoveTransaction}
            selectedTransaction={selectedTransaction}
            treatmentId={treatmentId}
          />
        </>
      )}
      <ViewTransactionDescriptionModal 
        showTransactionDescription= {showTransactionDescription}
        setShowTransactionDescription= {setShowTransactionDescription}
        selectedTransaction={selectedTransaction}
      />
      <div className="bg-white rounded shadow p-6 px-10 block h-auto">
        <div className="flex justify-between">
          <h1 className=" text-2xl text-secondary">
            Transactions
          </h1>
          {(user.user_type === USER_TYPES.ROOT || user.user_type === USER_TYPES.STAFF) && (
          <div>
            <SecondaryButtonAccent
              onClick={() => setShowAddTreatmentTransaction(true)}
              text="Add"
              icon={<PlusIcon fill={COLORS.colorPrimary} />}
            />
          </div>
          )}
        </div>  
        {!treatmentTransactions.length ?
        <p className="mb-5 flex text-secondary items-center mt-6">
          No invoices have been emitted for this treatment.
        </p>
        :
        <div className="flex flex-col mt-5 w-full">
          <TreatmentTransactionDetails
            setSelectedTransaction={setSelectedTransaction}
            setShowRemoveTransaction={setShowRemoveTransaction}
            treatmentInfo={treatmentInfo}
            user={user}
            allTreatmentTransactions={treatmentTransactions}
            setShowTransactionDescription={setShowTransactionDescription}
          /> 
          {user.user_type === USER_TYPES.PATIENT &&
          treatmentTransactions.find(transaction => transaction.is_paid === false) &&
          <div className='flex flex-row-reverse mt-8'>
            <PrimaryButton
              onClick={() => history.push({
                pathname: "/my-treatments/checkout",
                state: { treatmentInfo },
              })}
              text="Pay" 
            />
          </div>
          }
        </div>
        }
      </div>
    </React.Fragment>
  );
}